<template>
    <div class="about__section">
        <h3>{{ l('ABOUT.USER_HEADING') }}</h3>
        <dl v-if="user">
            <dt>{{ l('ABOUT.USER_NAME') }}</dt>
            <dd>
                {{ user.username }}
                <span v-if="user.entraIDToken"
                      class="label label-default">{{ l('ABOUT.USER_ENTRA_ID') }}</span>
            </dd>

            <dt>{{ l('ABOUT.USER_ID') }}</dt>
            <dd>{{ user.ID }}</dd>

            <dt>{{ l('ABOUT.COMPANY_NAME') }}</dt>
            <dd>{{ user.company.name }}</dd>

            <dt>{{ l('ABOUT.COMPANY_ID') }}</dt>
            <dd>{{ user.company.ID }}</dd>
        </dl>
    </div>
</template>

<script>
import { cloneDeep } from '@/functions/clone';
import { container } from '@/container';

export default {
    name: 'AboutUserSection',

    data() {
        return {
            user: null,
        };
    },

    created() {
        // Clone the current device in case Vue's reactivity messes up the User object.
        this.user = cloneDeep(container.userService.currentUser);
    },
};
</script>
